import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import * as jQuery from "jquery";

import { EntityConfigService } from "../services/entity-config-service";
import { NotifyService } from "../services/notify-service";
import { AlertService } from "../services/alert-service";
import { EntityService } from "../services/entity-service";
import { WorkflowConfigService } from "../services/workflow-config-service";
import { Dictionary } from "lodash";
import { IWFActionRole, IParty } from "../ts/rlAdmin.models";
import { ContactService } from "../services/contact-service";
import { CharTypeUtil } from "../ts/rlAdmin.utils";


export function RLAddAlertToCharacteristic() {
	var directive: ng.IDirective = {
		restrict: "AE",
		template: require("/assets/app/templates/add-alert-to-characteristic.html"),
		controller: RLAddAlertToCharacteristicController,
		controllerAs: "aaVM",
		bindToController: true,
		scope: {
			charTypeID: "=charTypeId",
			templateID: "=templateId",
			charID: "=charId",
			charDataType: "=",
			charLabel: "=",
			charValue: "=",
			entityID: "=entityId"
		},
		require: "rlAddAlertToCharacteristic",
		link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: RLAddAlertToCharacteristicController) => {
			var alertPanel = jQuery(element).find(".add-alert-panel").scotchPanel({
				containerSelector: element.find(".alert-table")[0],
				direction: "top",
				duration: 500,
				transition: "ease",
				forceMinHeight: true,
				minHeight: "300px"
			});
		}
	};
	return directive;
}

export class RLAddAlertToCharacteristicController {

	public static $inject = [
		"$scope",
		"$q",
		"notifyService",
		"alertService",
		"entityService",
		"entityConfigService",
		"workflowConfigService",
		"contactService",
	];

	private charTypeID: number;
	private charID: number;
	private templateID: number;
	public charDataType: number;
	public charLabel: string;
	private charValue: Models.ICharDataValue;
	public entityID: string;
	private recID: number;
	private recTitle: string;
	private panelToggle: (openToggle: boolean) => void;
	public alertFrequencyTypes: Models.IAlertFrequency[] = [];
	public alertTimeframeTypes: Models.IAlertTimeframe[] = [];
	public alerts: Models.IAlert[] = [];
	private configAlerts: Models.IAlert[] = [];
	private recAlerts: Models.IAlert[] = [];
	public emails: string[] = [];
	public newEmail: string;
	public selectedAlert: Models.IAlert = null;
	public disableQtyFrqFields: boolean = false;
	private showAlerts: boolean = false;
	public infoToolTip: boolean = false;
	public alertNotifications: Models.IWFRoleNotification[] = [];
	public selectedAlertNotification: Models.IWFRoleNotification = undefined;
	public showAlertNotificationPanel: boolean = false;
	public disableSave: boolean = false;

	public listRoles: Models.IWFActionRole[] = [];
	public selectedNotificationRoles: Models.IWFActionRole[] = [];
	public selectAllRoles: boolean = false;
	public selectAllParties: boolean = false;
	public isComponentModule: boolean = false;
	public expandRoles: boolean = false;
	public expandParties: boolean = false;
	public listParties: Models.IParty[] = [];
	public selectedNotificationParties: Models.IParty[] = [];


	public otherTemplateDates: Models.ICharacteristicMetaData[] = [];
	public otherTemplateDatesLookup: Dictionary<string> = {};

	public containsOptions: Models.IAlertContainsType[];
	public containsOptionsLookup: Dictionary<string> = {};

	public constructor(private readonly $scope: ng.IScope,
		private readonly $q: ng.IQService,
		private readonly notifyService: NotifyService,
		private readonly alertService: AlertService,
		private readonly entityService: EntityService,
		private readonly entityConfigService: EntityConfigService,
		private readonly workflowConfigService: WorkflowConfigService,
		private readonly contactService: ContactService
	) {

		$scope.$watchCollection(() => [this.charTypeID, this.templateID, this.charID, this.entityID],
			(newValue, oldValue) => {
				if (this.charTypeID != null
					&& this.templateID != null
					&& this.charID != null
					&& this.entityID != null
					&& !this.entityID.match('r-1')) {

					this.recID = Utils.IdBuilder.splitEntityID(this.entityID).recID;
					this.LoadAlertValues();
					this.LoadAlerts();
				}
			});

		this.panelToggle = (openToggle: boolean) => { };

		$scope.$on('executeViewAlerts', () => {
			this.ViewAlerts();
		});

		$scope.$on('executeNewAlert', () => {
			this.NewAlert(this.selectedAlertNotification);
		});

		$scope.$watch(() => this.newEmail, (newValue, oldValue) => {
			if (newValue != oldValue && !_.isEmpty(newValue)) {
				this.disableSave = true;
			}
		});
	}

	private ViewAlerts() {
		if (this.showAlerts) {
			this.showAlerts = false;
		}
		else {
			this.showAlerts = true;
		}
	}

	private LoadAlerts() {
		this.notifyService.startProgress();
		let split = Utils.IdBuilder.splitEntityID(this.entityID);

		let promises: ng.IPromise<void>[] = [];

		if (split.recID > 0) {
			let promise1 = this.alertService.getAlertList(this.charTypeID, this.templateID, this.charID, this.recID)
				.then((results) => {
					this.recAlerts = results;
					this.alertService.getConfigAlertList(this.charTypeID, this.templateID, this.charID, -1)
						.then((results) => {
							this.configAlerts = results;
						})
						.then(() => {
							this.alerts = this.recAlerts.concat(this.configAlerts);
							_.forEach(this.alerts, (al) => {
								if (_.isEmpty(al.bodyHTML)) {
									al.bodyHTML = al.body;
								}
							});
							if (this.alerts.length == 0) {
								this.NewAlert(this.selectedAlertNotification);
							}
						})
				});

			promises.push(promise1);

			let promise2 = this.entityService.getEntity(this.entityID)
				.then((results) => {
					this.recTitle = results.record.title;
				});

			promises.push(promise2);
		}

		let templatePromise = this.entityConfigService.getCharacteristicTemplate(this.charTypeID, this.templateID)
			.then(result => {
				this.otherTemplateDates = result.characteristicMetaDatas
					.filter(x => x.dataTypeID === Consts.CharDataTypeIDs.CharDataTypes.date
						&& x.characteristicID !== this.charID);

				this.otherTemplateDatesLookup = this.otherTemplateDates
					.reduce<Dictionary<string>>((lookup, next) => {
						lookup[next.characteristicID] = next.label;
						return lookup;
					}, {});
			});

		let containsOptionsPromise = this.alertService.getAlertContainsValueTypeList()
			.then(result => {
				this.containsOptions = result;
				this.containsOptionsLookup = this.alertService.alertContainsValuesToLookup(result);
			});

		var promise3 = this.entityConfigService.getAlertNofitications(this.charTypeID, this.templateID)
			.then((response) => {
				_.each(response, (item) => {
					if (!_.any(this.alertNotifications, an => an.id == item.id)) {
						this.alertNotifications.push(item);
					}
				});
			});

		promises.push(templatePromise);
		promises.push(containsOptionsPromise);
		promises.push(promise3);
		return this.$q.all(promises)
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	private LoadAlertValues() {
		this.notifyService.startProgress();

		let alertFrequencyPromise = this.alertService.getAlertFrequencyList()
			.then((results) => {
				this.alertFrequencyTypes = results;
			});

		let alertTimeframePromise = this.alertService.getAlertTimeframeList()
			.then((results) => {
				this.alertTimeframeTypes = results;
			});


		let promises = [alertFrequencyPromise, alertTimeframePromise];

		return this.$q.all(promises)
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	public DeleteAlert(alert) {
		this.notifyService.startProgress();
		this.alertService.deleteAlert(alert.id)
			.then((results) => {
				this.notifyService.notifySuccess("Alert Deleted");
			})
			.finally(() => {
				this.notifyService.endProgress();
				this.LoadAlerts();
				this.$scope.$emit('requestAlertsRefresh');
			});
	}

	public UpdateAlert() {
		this.notifyService.startProgress();
		this.selectedAlert.toEmail = this.emails.join(';');
		this.selectedAlert.selectedRoleIDs = _.map(this.selectedNotificationRoles, 'roleID').join(';');
		this.selectedAlert.selectedPartyIDs = _.map(this.selectedNotificationParties, 'partyID').join(';');
		if (this.FieldHasNoValue()) {
			this.selectedAlert.createEmailInvite = false;
		}

		let promises: ng.IPromise<any>[] = [];
		if (this.selectedAlert.ID == '') {
			let createPromise = this.alertService.createAlert(this.selectedAlert)
				.then((result) => {
					this.notifyService.notifySuccess("Alert Created");
				});

			promises.push(createPromise);
		} else {
			let updatePromise = this.alertService.updateAlert(this.selectedAlert)
				.then((result) => {
					this.notifyService.notifySuccess("Alert Updated");
				});

			promises.push(updatePromise);
		}

		return this.$q.all(promises)
			.finally(() => {
				this.showAlerts = false;
				this.ResetFields();
				this.panelToggle(false);
				this.disableSave = false;
				this.showAlertNotificationPanel = false;
				this.notifyService.endProgress();
				this.LoadAlerts();
				this.$scope.$emit('requestAlertsRefresh');
			});
	}

	public NewAlert(selectedAlertNotification: Models.IWFRoleNotification) {
		this.disableSave = false;
		this.BuildNotificationCheckBox();
		this.selectedAlert = {
			divisionID: null,
			charTypeID: this.charTypeID,
			templateID: this.templateID,
			charID: this.charID, recordID: this.recID, ID: '',
			fromID: null,
			body: "",
			attachment: "",
			sequenceNumber: null,
			createdBy: null,
			createdAt: "",
			updatedBy: null,
			updatedAt: "",
			status: "",
			processID: null,
			messageID: null,
			label: "",
			quantity: 1,
			frequencyID: 1,
			frequencyLabel: _.find(this.alertFrequencyTypes, f => f.frequencyID == 1).frequencyLabel,
			timeframeID: 1,
			timeframeLabel: _.find(this.alertTimeframeTypes, t => t.timeframeID == 1).timeframeLabel,
			selectedPartyIDs: "",
			selectedRoleIDs: "",
			subject: selectedAlertNotification == undefined ? "Rightsline Date Alert - " + this.recID + " - " + this.recTitle : selectedAlertNotification.subject,
			bodyHTML: selectedAlertNotification == undefined ? "" : selectedAlertNotification.bodyHTML, toEmail: "",
			alertWhenSetOrUpdated: false,
			createCustomAlert: true,
			createEmailInvite: false,
			emailInviteUID: null,
			emailUpdateSequence: 0,
			templateDateCharId: null,
			templateDateContainsType: null,
			doNotSendIfRecordInactive: false,
			triggerSNSOrSQS: false,
			notifyChildrenPartyIds: ""
		};

		this.AddNewEmail(Consts.userEmail);
		this.showAlerts = true;
		this.showAlertNotificationPanel = true;
	}

	public EditAlert(alert) {
		this.BuildNotificationCheckBox();
		this.disableSave = false;
		this.LoadAlertValues();
		this.selectedAlert = _.clone(alert);
		this.emails = this.selectedAlert.toEmail.split(";");
		this.CheckTimeframe(alert.timeframeID);
		this.showAlertNotificationPanel = true;
	}

	public CheckTimeframe(timeFrameID) {
		if (timeFrameID == 2) {
			//Disable Quantity and Frequency
			this.disableQtyFrqFields = true;
		}
		else {
			this.disableQtyFrqFields = false;
		}
	}

	public CancelAlert() {
		this.showAlerts = false;
		this.showAlertNotificationPanel = false;
		this.ResetFields();
	}

	public AddNewEmail(email) {
		if (!email || email == '') return;
		this.emails = _.union(this.emails, [email]) // prevents duplicates
		this.newEmail = '';
		this.disableSave = false;
	}

	public RemoveEmail(email) {
		let index = this.emails.indexOf(email);
		this.emails.splice(index, 1);
	}

	private ResetFields() {
		this.disableQtyFrqFields = false;
		this.emails = [];
		this.selectedNotificationRoles = [];
		this.selectedNotificationParties = [];
		this.newEmail = "";
	}

	private BuildNotificationCheckBox() {
		this.ResetFields();
		this.LoadRoles();
		//Check if module
		if (Utils.CharUtil.IsModuleLevelCharType(this.charTypeID)) {
			this.LoadParties();
		}
	}

	private LoadParties() {
		this.listParties = [];
		this.contactService.getContactsForEntity(this.entityID)
			.then((result) => {
				let filteredParties = _.filter(result, (party: Models.IContactParty) => party.party.visibilityIndicator >= 1);
				_.forEach(filteredParties, (fp) => {
					this.listParties.push(fp.party);
				});
				//Load already selected parties and select them visually 
				let selectedPartyIDs = this.selectedAlert.selectedPartyIDs.split(";");
				_.forEach(selectedPartyIDs, (p) => {
					let selectedParty = _.filter(this.listParties, party => party.partyID.toString() == p)
					if (selectedParty.length == 1) {
						this.selectedNotificationParties.push(selectedParty[0]);
					}
				});
			});
	}

	private ToggleAllParties() {
		this.selectedNotificationParties = [];
		if (this.selectAllParties) {
			this.selectedNotificationParties = this.selectedNotificationParties.concat(this.listParties);
		}
	}

	private ToggleParty(party: IParty) {
		//Check if party is already selected and if so remove
		if (_.filter(this.selectedNotificationParties, p => p.partyID == party.partyID).length == 1) {
			var partyRemoveIndex = _.indexOf(this.selectedNotificationParties, _.filter(this.selectedNotificationParties, p => p.partyID == party.partyID)[0]);
			this.selectedNotificationParties.splice(partyRemoveIndex, 1);
		}
		//Add it otherwise
		else {
			this.selectedNotificationParties.push(party);
		}
	}

	private ToggleExpandParties() {
		this.expandParties = !this.expandParties;
	}

	private ToggleExpandRoles() {
		this.expandRoles = !this.expandRoles;
	}

	private LoadRoles() {
		this.workflowConfigService.getRoles()
			.then((result) => {
				this.listRoles = result;
				//Load already selected roles and select them visually
				let selectedRoleIDs = this.selectedAlert.selectedRoleIDs.split(";");
				_.forEach(selectedRoleIDs, (r) => {
					let selectedRole = _.filter(this.listRoles, role => role.roleID.toString() == r)
					if (selectedRole.length == 1) {
						this.selectedNotificationRoles.push(selectedRole[0]);
					}
				});
			});
	}

	public ToggleAllRoles() {
		this.selectedNotificationRoles = [];
		if (this.selectAllRoles) {
			this.selectedNotificationRoles = this.selectedNotificationRoles.concat(this.listRoles);
		}
	}

	public ToggleRole(role: IWFActionRole) {
		//Check if role is already selected and if so remove
		if (_.filter(this.selectedNotificationRoles, r => r.roleID == role.roleID).length == 1) {
			var roleRemoveIndex = _.indexOf(this.selectedNotificationRoles, _.filter(this.selectedNotificationRoles, r => r.roleID == role.roleID)[0]);
			this.selectedNotificationRoles.splice(roleRemoveIndex, 1);
		}
		//Add it otherwise
		else {
			this.selectedNotificationRoles.push(role);
		}
	}

	public FieldHasNoValue(): boolean {
		if (this.charValue) {
			if (!_.isEmpty(this.charValue.value)) {
				return false;
			}

			this.selectedAlert.createEmailInvite = false;
			return true;
		}

		this.selectedAlert.createEmailInvite = false;
		return true;
	}

	public SelectFirstTemplateDate() {
		if (_.any(this.otherTemplateDates)) {
			this.selectedAlert.templateDateCharId = _.first(this.otherTemplateDates).characteristicID;
			this.selectedAlert.templateDateContainsType = _.first(this.containsOptions).value;
		}
	}

	public RemoveSelectedTemplateDate() {
		this.selectedAlert.templateDateCharId = null;
		this.selectedAlert.templateDateContainsType = null;
	}
}